import { Box, Grid, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useFormArray } from 'shared/hooks/use-form-array';
import { LwButton } from 'redesign';
import { IconAdd } from 'assets/img';
import { useTranslation } from 'react-i18next';
import { SegmentsForEdit, TimeSlotFormContext } from './time-slot.types';
import { Timeslot } from './time-slot';

export const TimeSlotWrapper = ({
  isCreateMode,
  additionalAvailabilities,
}: {
  isCreateMode: boolean;
  additionalAvailabilities?: SegmentsForEdit[];
}) => {
  const timeslots = useFormArray<TimeSlotFormContext, 'availability'>('availability', {
    segmentId: '',
    utcStartDateTime: '',
    utcEndDateTime: '',
  });
  const { watch, formState } = useFormContext<TimeSlotFormContext>();
  const { t } = useTranslation('all-platforms-common');
  const workerId = watch('workerSelect');
  const hasErrors = !!formState.errors.availability?.length;
  const isAddButtonDisabled = !workerId || !formState.isValid || hasErrors;

  return (
    <StyledContainer>
      {timeslots.fields.map((timeslot, index) => (
        <>
          <Timeslot
            key={timeslot.id}
            index={index}
            additionalAvailabilities={additionalAvailabilities}
            handleDelete={timeslots.deleteElement}
          />
        </>
      ))}
      {isCreateMode ? (
        <Grid item xs={3} justifyContent={'center'} display="flex">
          <LwButton
            startIcon={<IconAdd width={18} height={18} />}
            color="tertiary"
            onClick={() => timeslots.appendElement()}
            disabled={isAddButtonDisabled}
          >
            {t('edit_availability.add_timeslot', { ns: 'all-platforms-common' })}
          </LwButton>
        </Grid>
      ) : null}
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));
